import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { translations } from "../app_components/Translation";
import arivuEN from "../assets/logo/ArivuEN.png";
import arivuFR from "../assets/logo/ArivuFR.png";
import { useAuth } from "../authentication/AuthProvider";
import { usePendingUser } from "../authentication/PendingUserContext";
import { useContextProvider } from "../components/page-context/ContextProvider";
import config from "../config";
import "../style/pages-style/Register.css";

function Register() {
  const { selectedLanguage } = useContextProvider();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [recheckPassword, setRecheckPassword] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [company_name, setCompany_name] = useState("");
  const [email, setEmail] = useState("");
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const [isInvalid, setIsInvalid] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);

  const auth = useAuth();
  const navigate = useNavigate();
  const { setPendingUser } = usePendingUser();
  const selectedText = translations[selectedLanguage]?.register || {};

  // Dynamically set the logo based on the selected language
  const logo = selectedLanguage === "en" ? arivuEN : arivuFR;

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== recheckPassword) {
      setPasswordsMatch(false);
      setIsInvalid(false);
      return;
    }

    const user_info = {
      user_id: username,
      password: password,
      company_name: company_name,
      address: address,
      email: email,
      phone_number: phoneNumber,
      lat: lat,
      lon: lon,
    };

    try {
      const response = await fetch(`${config.apiUrl}/register_user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(user_info),
      });

      const data = await response.json();

      if (response.ok) {
        setIsInvalid(false);
        setPendingUser(username);
        navigate("/terms_and_conditions");
      } else {
        setIsInvalid(true);
        console.error("Registration failed:", data.message);
      }
    } catch (error) {
      console.error("Network error:", error);
      setIsInvalid(true);
    }
  };

  const toggleVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    <div className="register-container">
      <div className="logo-container-arivu ">
        <img src={logo} alt="logo" style={{ height: "75px" }} />
      </div>

      <div className="divider"></div>

      {(isInvalid || !passwordsMatch) && <div className="error-message">{isInvalid ? selectedText.invalidCredentials : selectedText.passwordsDoNotMatch}</div>}

      <form onSubmit={handleSubmit} className="form">
        <div className="input-group">
          <div className="input-field">
            <label htmlFor="company-name-input">{selectedText.companyName}</label>
            <input type="text" id="company-name-input" placeholder={selectedText.enterCompanyName} value={company_name} onChange={(e) => setCompany_name(e.target.value)} />
          </div>
          <div className="input-field">
            <label htmlFor="username-input">{selectedText.username}</label>
            <input type="text" id="username-input" placeholder={selectedText.enterUsername} value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>
        </div>

        <div className="input-group">
          <div className="input-field">
            <label htmlFor="email-input">{selectedText.email}</label>
            <input type="email" id="email-input" placeholder={selectedText.enterEmail} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="input-field">
            <label htmlFor="phone-number-input">{selectedText.phoneNumber}</label>
            <input type="text" id="phone-number-input" placeholder={selectedText.enterPhoneNumber} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
          </div>
        </div>

        <div className="input-field-address">
          <label htmlFor="address-input">{selectedText.address}</label>
          <input type="text" id="address-input" placeholder={selectedText.enterAddress} value={address} onChange={(e) => setAddress(e.target.value)} />
        </div>

        <div className="input-group">
          <div className="input-field">
            <label htmlFor="lat-input">{selectedText.latitude}</label>
            <input type="text" id="lat-input" placeholder={selectedText.enterLatitude} value={lat} onChange={(e) => setLat(e.target.value)} />
          </div>
          <div className="input-field">
            <label htmlFor="lon-input">{selectedText.longitude}</label>
            <input type="text" id="lon-input" placeholder={selectedText.enterLongitude} value={lon} onChange={(e) => setLon(e.target.value)} />
          </div>
        </div>

        <div className="input-group">
          <div className="input-field">
            <label htmlFor="password-input">{selectedText.password}</label>
            <div className="password-input-group">
              <input
                type={passwordVisible ? "text" : "password"}
                id="password-input"
                placeholder={selectedText.enterPassword}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FontAwesomeIcon icon={passwordVisible ? faEyeSlash : faEye} onClick={toggleVisibility} className="toggle-password-visibility-button" />
            </div>
          </div>
          <div className="input-field">
            <label htmlFor="recheck-password-input">{selectedText.recheckPassword}</label>
            <div className="password-input-group">
              <input
                type={passwordVisible ? "text" : "password"}
                id="recheck-password-input"
                placeholder={selectedText.enterRecheckPassword}
                value={recheckPassword}
                onChange={(e) => setRecheckPassword(e.target.value)}
              />
              <FontAwesomeIcon icon={passwordVisible ? faEyeSlash : faEye} onClick={toggleVisibility} className="toggle-password-visibility-button" />
            </div>
          </div>
        </div>
        <button className="register-button" type="submit">
          {selectedText.register}
        </button>
      </form>
    </div>
  );
}

export default Register;
